import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const it = {
  nav: {
    home: 'Home',
    atelier: 'Atelier',
    engagement: 'Anelli di Fidanzamento',
    wedding: 'Fedi Nuziali',
    wave: 'Linea Wave',
    pronta: 'Collezione Privata',
    gemme: 'Gemme Rare',
    storia: 'Legacy',
    contatti: 'Contatti',
    account: 'Account',
    login: 'Accedi',
    register: 'Registrati',
    logout: 'Esci',
    admin: 'Admin',
    profile: 'Profilo',
    orders: 'Ordini',
    wishlist: 'Wishlist',
    configurations: 'Configurazioni',
  },
  home_categories: {
    overline: 'Scopri per categoria',
    title: 'La Maison Harizi',
    engagement: 'Anelli di\nfidanzamento',
    wedding: 'Fedi\nnuziali',
    wave: 'Linea\nWave',
    rings: 'Anelli',
    private: 'Collezione\nPrivata',
    create: 'Crea il tuo\ngioiello',
  },
  categories: {
    engagement: {
      overline: 'La promessa',
      title: 'Anelli di Fidanzamento',
      intro: 'Un solitario che racconta l\'irripetibile.\nGemme certificate, tagli sartoriali e montature in oro 18k modellate a mano dai maestri della maison Harizi.',
      cta: 'Disegna il tuo solitario',
      seo_title: 'Anelli di Fidanzamento — Solitari su misura | Harizi Gioielli',
      seo_desc: 'Anelli di fidanzamento su misura con diamanti e gemme rare certificate. Design sartoriale, oro 18k, artigianalità italiana.',
    },
    wedding: {
      overline: 'Il rito eterno',
      title: 'Fedi Nuziali',
      intro: 'Fedi nuziali in oro giallo, bianco o rosa 18k.\nProfili classici, comfort-fit e incisioni personalizzate: ogni coppia riceve una fede unica, forgiata a mano nell\'atelier Harizi.',
      cta: 'Richiedi una consulenza',
      seo_title: 'Fedi Nuziali — Oro 18k su misura | Harizi Gioielli',
      seo_desc: 'Fedi nuziali artigianali in oro giallo, bianco e rosa 18k. Comfort-fit, incisioni personalizzate e assistenza dedicata.',
    },
    wave: {
      overline: 'Movimento contemporaneo',
      title: 'Linea Wave',
      intro: 'L\'obiettivo della linea Wave è di valorizzare la gemma, che è l\'unica protagonista dell\'anello. Sia la forma ovale della gemma che la montatura a onda richiamano il movimento della Terra e il cambiamento continuo. Perché accettare che la vita è una trasformazione infinita è parte della pace interiore. E questa perfetta collezione imperfetta non racconta solo la propria storia, ma anche la tua.',
      cta: 'Configura un Wave',
      seo_title: 'Linea Wave — Anelli d\'autore | Harizi Gioielli',
      seo_desc: 'La collezione Wave: anelli d\'autore con fascia sinuosa e gemme centrali ovali. Design contemporaneo, alta gioielleria italiana.',
    },
  },
  hero: {
    overline: 'Harizi Gioielli',
    title: 'Jewelry as Legacy',
    subtitle: 'Gemme rare. Artigianalità senza tempo. Pezzi unici per chi sceglie l\'eternità.',
    cta_atelier: 'Crea il tuo gioiello',
    cta_collection: 'Scopri la collezione',
  },
  sections: {
    alta_gioielleria: { overline: 'Alta Gioielleria', title: 'L\'arte di pochi.\nIl privilegio di chi sa.', body: 'Ogni creazione Harizi nasce da una visione orafa di altissima sartoria: gemme selezionate al mondo, montature progettate per durare oltre il tempo.' },
    gemme: { overline: 'Gemme Rare', title: 'Origine certificata.\nUnicità custodita.', body: 'Zaffiri Kashmir, padparadscha del Ceylon, rubini Mogok. Ogni pietra accompagnata da certificazione gemmologica internazionale.' },
    atelier: { overline: 'Harizi Atelier', title: 'Disegna l\'irripetibile.', body: 'Esperienza configuratore in tempo reale. Gemma, taglio, montatura: ogni dettaglio scolpito intorno alla tua storia.', cta: 'Apri l\'atelier' },
    pronta: { overline: 'Collezione Privata', title: 'Pezzi unici.\nDisponibili oggi.', body: 'Una selezione limitata di creazioni Harizi pronte per essere indossate. Ogni pezzo, una storia conclusa.', cta: 'Esplora' },
    artigianalita: { overline: 'Artigianalità', title: 'Le mani.\nIl tempo.\nLa pazienza.', body: 'Ottanta ore di lavoro su un solo anello. Tre generazioni di sapere orafo. Nessuna macchina sostituisce l\'occhio del maestro.' },
    certificazioni: { overline: 'Certificazioni', title: 'Gemmological Institutes', body: 'GIA · SSEF · Gübelin · AGL — la nostra promessa di trasparenza è garantita dai laboratori più autorevoli al mondo.' },
    concierge: { overline: 'Un\'Esperienza Personale', title: 'Un\'esperienza personale.', body: 'Consulenza dedicata via WhatsApp e appuntamenti riservati ad ogni esigenza.', cta: 'Ricevi assistenza su WhatsApp' },
  },
  footer: {
    newsletter: 'Iscriviti alla newsletter privata',
    newsletter_sub: 'Anticipazioni esclusive, eventi privati, nuove gemme.',
    email_placeholder: 'La vostra email',
    subscribe: 'Iscriviti',
    sections: { atelier: 'Atelier', maison: 'Maison', servizi: 'Servizi', legal: 'Legale' },
    rights: 'Tutti i diritti riservati',
    shipping: 'Spedizioni Internazionali Sicure',
  },
  atelier: {
    title: 'Atelier Configuratore',
    subtitle: 'Crea un pezzo irripetibile',
    section_gem: 'Gemma',
    section_carat: 'Caratura',
    section_color: 'Colore',
    section_clarity: 'Purezza',
    section_cut: 'Taglio',
    section_origin: 'Origine',
    section_treatment: 'Trattamento',
    section_ring_type: 'Tipologia anello',
    section_metal: 'Materiale',
    section_finish: 'Finitura',
    section_thickness: 'Spessore fascia',
    section_size: 'Misura',
    section_engraving: 'Incisione',
    engraving_placeholder: 'Iniziali, data, parola...',
    extras: 'Pietre aggiuntive',
    total: 'Prezzo indicativo',
    save: 'Salva configurazione',
    add_to_cart: 'Procedi all\'ordine',
    contact_concierge: 'Assistenza WhatsApp',
    rotate_hint: 'Trascina per ruotare · pizzica per zoomare',
  },
  pronta: {
    title: 'Collezione Privata',
    subtitle: 'Pezzi unici disponibili',
    view_details: 'Dettagli',
    sold: 'Venduto',
    download_cert: 'Scarica certificato',
  },
  product: {
    gem_details: 'Dettagli gemmologici',
    technical: 'Specifiche tecniche',
    origin: 'Origine',
    treatment: 'Trattamento',
    carat: 'Caratura',
    cut: 'Taglio',
    clarity: 'Purezza',
    color: 'Colore',
    metal: 'Materiale',
    certificate: 'Certificato gemmologico',
    buy_now: 'Acquista ora',
    contact: 'Richiedici info',
    save: 'Salva nei desideri',
  },
  checkout: {
    title: 'Ordine',
    step1: 'Riepilogo',
    step2: 'Identità',
    step3: 'Spedizione',
    step4: 'Pagamento',
    step5: 'Conferma',
    summary: 'Riepilogo ordine',
    subtotal: 'Subtotale',
    shipping: 'Spedizione',
    free: 'Inclusa',
    total: 'Totale',
    first_name: 'Nome',
    last_name: 'Cognome',
    email: 'Email',
    phone: 'Telefono',
    address: 'Indirizzo',
    city: 'Città',
    postal: 'CAP',
    country: 'Paese',
    pay_stripe: 'Paga con carta · Apple Pay · Google Pay',
    pay_bank: 'Bonifico bancario',
    place_order: 'Conferma e paga',
    notes: 'Note per il concierge',
    success: 'Ordine confermato',
    success_msg: 'Grazie. Il vostro concierge personale vi contatterà a breve.',
    next: 'Avanti',
    back: 'Indietro',
  },
  auth: {
    login: 'Accedi',
    register: 'Crea account',
    email: 'Email',
    password: 'Password',
    first_name: 'Nome',
    last_name: 'Cognome',
    forgot: 'Password dimenticata?',
    no_account: 'Non hai un account?',
    have_account: 'Hai già un account?',
    sign_in: 'Entra',
    sign_up: 'Registrati',
    welcome: 'Benvenuto nella maison',
  },
  account: {
    title: 'Il vostro spazio',
    profile: 'Profilo',
    orders: 'I miei ordini',
    wishlist: 'Wishlist',
    configurations: 'Configurazioni salvate',
    no_orders: 'Nessun ordine ancora.',
    no_wishlist: 'Wishlist vuota.',
    no_configs: 'Nessuna configurazione salvata.',
    save_profile: 'Salva',
  },
  admin: {
    title: 'Pannello Admin',
    dashboard: 'Dashboard',
    products: 'Prodotti',
    orders: 'Ordini',
    customers: 'Clienti',
    newsletter: 'Newsletter',
    settings: 'Contatti & Settings',
    revenue: 'Fatturato',
    total_orders: 'Ordini',
    total_products: 'Prodotti',
    total_customers: 'Clienti',
    add_product: 'Nuovo prodotto',
    edit: 'Modifica',
    delete: 'Elimina',
    save: 'Salva',
  },
  common: {
    loading: 'Un momento...',
    error: 'Si è verificato un errore',
    currency: '€',
    indicative_price: 'Prezzo indicativo soggetto a verifica gemmologica finale',
  },
};

const en = {
  nav: {
    home: 'Home', atelier: 'Atelier',
    engagement: 'Engagement Rings',
    wedding: 'Wedding Bands',
    wave: 'Linea Wave',
    pronta: 'Private Collection', gemme: 'Rare Gems', storia: 'Legacy', contatti: 'Contact',
    account: 'Account', login: 'Sign In', register: 'Register', logout: 'Sign Out', admin: 'Admin',
    profile: 'Profile', orders: 'Orders', wishlist: 'Wishlist', configurations: 'Configurations',
  },
  home_categories: {
    overline: 'Explore by category',
    title: 'The Harizi Maison',
    engagement: 'Engagement\nrings',
    wedding: 'Wedding\nbands',
    wave: 'Linea\nWave',
    rings: 'Rings',
    private: 'Private\nCollection',
    create: 'Create your\njewel',
  },
  categories: {
    engagement: {
      overline: 'The promise',
      title: 'Engagement Rings',
      intro: 'A solitaire that tells the unrepeatable.\nCertified gems, tailored cuts and hand-forged 18k gold settings crafted by Harizi master goldsmiths.',
      cta: 'Design your solitaire',
      seo_title: 'Engagement Rings — Bespoke Solitaires | Harizi Gioielli',
      seo_desc: 'Bespoke engagement rings featuring certified diamonds and rare gems. Tailored design, 18k gold, Italian craftsmanship.',
    },
    wedding: {
      overline: 'The eternal rite',
      title: 'Wedding Bands',
      intro: 'Wedding bands in yellow, white or rose 18k gold.\nClassic profiles, comfort-fit and custom engravings: every couple receives a unique band, hand-forged in the Harizi atelier.',
      cta: 'Request a consultation',
      seo_title: 'Wedding Bands — Bespoke 18k gold | Harizi Gioielli',
      seo_desc: 'Handcrafted wedding bands in yellow, white and rose 18k gold. Comfort-fit, custom engravings and dedicated concierge.',
    },
    wave: {
      overline: 'Contemporary motion',
      title: 'Linea Wave',
      intro: 'The purpose of the Wave line is to celebrate the gemstone, the ring\'s sole protagonist. Both the gem\'s oval shape and its wave setting evoke the movement of the Earth and continuous change. Accepting that life is an infinite transformation is part of inner peace. This perfectly imperfect collection tells not only its own story, but yours too.',
      cta: 'Configure a Wave',
      seo_title: 'Linea Wave — Signature rings | Harizi Gioielli',
      seo_desc: 'The Wave collection: signature rings with a sinuous band and oval centre gems. Contemporary design, Italian high jewellery.',
    },
  },
  hero: {
    overline: 'Harizi Gioielli',
    title: 'Jewelry as Legacy',
    subtitle: 'Rare gemstones. Timeless craft. Unique pieces for those who choose eternity.',
    cta_atelier: 'Create your jewel',
    cta_collection: 'Discover the collection',
  },
  sections: {
    alta_gioielleria: { overline: 'High Jewelry', title: 'The art of the few.\nThe privilege of the discerning.', body: 'Every Harizi creation is born from the highest goldsmith vision: gemstones selected from across the world, settings designed to outlast time.' },
    gemme: { overline: 'Rare Gemstones', title: 'Certified origin.\nGuarded uniqueness.', body: 'Kashmir sapphires, Ceylon padparadscha, Mogok rubies. Every stone backed by international gemmological certification.' },
    atelier: { overline: 'Harizi Atelier', title: 'Design the unrepeatable.', body: 'Real-time configurator experience. Stone, cut, setting: every detail sculpted around your story.', cta: 'Open the atelier' },
    pronta: { overline: 'Private Collection', title: 'Unique pieces.\nAvailable today.', body: 'A limited selection of Harizi creations ready to be worn. Each piece, a complete story.', cta: 'Explore' },
    artigianalita: { overline: 'Craftsmanship', title: 'The hands.\nThe time.\nThe patience.', body: 'Eighty hours of work on a single ring. Three generations of goldsmithing. No machine replaces the master\'s eye.' },
    certificazioni: { overline: 'Certifications', title: 'Gemmological Institutes', body: 'GIA · SSEF · Gübelin · AGL — our promise of transparency is backed by the world\'s most authoritative laboratories.' },
    concierge: { overline: 'A Personal Experience', title: 'A personal experience.', body: 'Dedicated WhatsApp consultations and private appointments tailored to your needs.', cta: 'Get WhatsApp assistance' },
  },
  footer: {
    newsletter: 'Join the private newsletter',
    newsletter_sub: 'Exclusive previews, private events, new gemstones.',
    email_placeholder: 'Your email',
    subscribe: 'Subscribe',
    sections: { atelier: 'Atelier', maison: 'Maison', servizi: 'Services', legal: 'Legal' },
    rights: 'All rights reserved',
    shipping: 'Secure International Shipping',
  },
  atelier: {
    title: 'Atelier Configurator',
    subtitle: 'Create an unrepeatable piece',
    section_gem: 'Gemstone', section_carat: 'Carat', section_color: 'Color', section_clarity: 'Clarity',
    section_cut: 'Cut', section_origin: 'Origin', section_treatment: 'Treatment',
    section_ring_type: 'Ring type', section_metal: 'Material', section_finish: 'Finish',
    section_thickness: 'Band thickness', section_size: 'Size', section_engraving: 'Engraving',
    engraving_placeholder: 'Initials, date, word...',
    extras: 'Additional stones', total: 'Indicative price',
    save: 'Save configuration', add_to_cart: 'Proceed to order',
    contact_concierge: 'WhatsApp assistance',
    rotate_hint: 'Drag to rotate · pinch to zoom',
  },
  pronta: { title: 'Private Collection', subtitle: 'Available unique pieces', view_details: 'Details', sold: 'Sold', download_cert: 'Download certificate' },
  product: {
    gem_details: 'Gemmological details', technical: 'Technical specifications', origin: 'Origin',
    treatment: 'Treatment', carat: 'Carat', cut: 'Cut', clarity: 'Clarity', color: 'Color',
    metal: 'Material', certificate: 'Gemmological certificate', buy_now: 'Purchase',
    contact: 'Request info', save: 'Save to wishlist',
  },
  checkout: {
    title: 'Order', step1: 'Summary', step2: 'Identity', step3: 'Shipping', step4: 'Payment', step5: 'Confirmation',
    summary: 'Order summary', subtotal: 'Subtotal', shipping: 'Shipping', free: 'Included', total: 'Total',
    first_name: 'First name', last_name: 'Last name', email: 'Email', phone: 'Phone',
    address: 'Address', city: 'City', postal: 'Postal code', country: 'Country',
    pay_stripe: 'Pay with card · Apple Pay · Google Pay', pay_bank: 'Bank transfer',
    place_order: 'Confirm & pay', notes: 'Notes for the concierge',
    success: 'Order confirmed', success_msg: 'Thank you. Your personal concierge will contact you shortly.',
    next: 'Next', back: 'Back',
  },
  auth: {
    login: 'Sign in', register: 'Create account', email: 'Email', password: 'Password',
    first_name: 'First name', last_name: 'Last name', forgot: 'Forgot password?',
    no_account: "Don't have an account?", have_account: 'Already have an account?',
    sign_in: 'Enter', sign_up: 'Register', welcome: 'Welcome to the maison',
  },
  account: {
    title: 'Your space', profile: 'Profile', orders: 'My orders', wishlist: 'Wishlist',
    configurations: 'Saved configurations', no_orders: 'No orders yet.', no_wishlist: 'Empty wishlist.',
    no_configs: 'No saved configurations.', save_profile: 'Save',
  },
  admin: {
    title: 'Admin Panel', dashboard: 'Dashboard', products: 'Products', orders: 'Orders',
    customers: 'Customers', newsletter: 'Newsletter', settings: 'Contacts & Settings',
    revenue: 'Revenue', total_orders: 'Orders', total_products: 'Products', total_customers: 'Customers',
    add_product: 'New product', edit: 'Edit', delete: 'Delete', save: 'Save',
  },
  common: {
    loading: 'One moment...', error: 'An error occurred', currency: '€',
    indicative_price: 'Indicative price, subject to final gemmological verification',
  },
};

i18n.use(initReactI18next).init({
  resources: { it: { translation: it }, en: { translation: en } },
  lng: localStorage.getItem('harizi_lang') || 'it',
  fallbackLng: 'it',
  interpolation: { escapeValue: false },
});

export default i18n;
